<template>
    <div class="form-group stylesoption">
        <label :for="'cill_measure' + '_' + cill">{{ title }}</label>
        <input :id="'cill_measure' + '_' + cill" type="number" v-model="localTarget" class="form-control"
               placeholder="" min="0" pattern="[0-9]">
        <div v-if="extra_text" v-html="extra_text"></div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        emits: ['update:target'],
        props: {
            cill: {
                required: true,
            },
            target: {
                default: ''
            },
            title: {
                default() {
                    return window.trans('general.cill') + ' Length (mm)';
                }
            },
            measurements: {
                required: false,
            },
            cill_type: {
                required: false,
            },
            extra_text: {
                default(){
                    return '';
                }
            },
        },
        computed: {
            localTarget: {
                get() {
                    return this.target
                },
                set(val) {
                    if(this.target !== val) {
                        this.$emit('update:target', val)
                    }
                }
            },
            cache_key(){
                return '_';
            },
        },
        watch: {
            'measurements.overall_width': {
                handler: function (val, oldVal) {
                    if(this.cill_type === 'door') {
                        this.localTarget = parseInt(this.measurements.overall_width) + 100;
                    }
                },
            },
            'measurements.left_width': {
                handler: function (val, oldVal) {
                    if(this.cill_type === 'left') {
                        this.localTarget = parseInt(this.measurements.left_width) + 100;
                    }
                },
            },
            'measurements.right_width': {
                handler: function (val, oldVal) {
                    if(this.cill_type === 'right') {
                        this.localTarget = parseInt(this.measurements.right_width) + 100;
                    }
                },
            },
        }
    }
</script>
